module.exports = __webpack_public_path__ + "img/a05f302.png";